"use client";
import { createContext as o } from "react";
const e = o({
  closeBanner: () => {
  }
});
export {
  e as BannerRootContext
};
//# sourceMappingURL=banner-root.context.js.map
